import SalesTaxConfigurationService from "../sales-tax-configuration/SalesTaxConfigurationService";
import StateSearch from "../sales-tax-configuration/models/StateSearch.model";
import {store} from "../../../plugins/vuex";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 25,
      page: 1,
      total: 0,
    },
    ordering: 'name',
    search: '',
    searchModel: new StateSearch(),
    extraFilters: {},
    expand: 'num_counties',
  }
};

export default {
  namespaced: true,
  state: {
    state: {
      modal: {
        show: false,
        object: null
      },
      tableData: getDefaultTableData(),
      countryStates: [],
      showStateDetails: [],
      showCountyDetails: [],
    },
    county: {
      modal: {
        show: false,
        object: null
      },
    },
    city: {
      modal: {
        show: false,
        object: null
      },
    },
  },
  actions: {
    showStateModal({commit}, object = null) {
      commit('showStateModal', _.cloneDeep(object));
    },
    hideStateModal({commit}) {
      commit('hideStateModal');
    },
    async getTableData({commit, dispatch, state}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await SalesTaxConfigurationService.getStatesByCountryCode(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
        for (const stateUuid of state.state.showStateDetails) {
          await dispatch('getCountiesByState', {load_all: true, state_uuid: stateUuid});
          for (const countyUuid of state.state.showCountyDetails) {
            await dispatch('getCitiesByCounty', {load_all: true, state_uuid: stateUuid, county_uuid: countyUuid});
          }
        }
      }

      return response;
    },
    getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.state.tableData;

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: currentTableData.ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      data.expand = currentTableData.expand;

      return data;
    },
    async updateTableSource({state}, {extraFilters}) {
      state.state.tableData.extraFilters = extraFilters;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new StateSearch({
        ...state.state.tableData.searchModel,
        ...searchModel
      }));
    },
    resetSearchModel({commit}) {
      commit('resetSearchModel')
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.state.tableData.extraFilters;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.state.tableData.pagination.limit;
      state.state.tableData = defaultTableData;
      state.state.tableData.extraFilters = extraFilters;
      dispatch('getTableData');
    },
    resetTableDataPaginationPage({state}) {
      state.state.tableData.pagination.page = 1;
    },
    async createState({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.createState(payload);
      if (response.success) {
        dispatch('getTableData');
        dispatch('getAllState', {load_all: true, country_code: payload.country_code});
      }
      return response;
    },
    async updateState({commit, dispatch}, payload) {
      const response = await SalesTaxConfigurationService.updateState(payload);
      if (response.success) {
        commit('updateState', response.body);
        dispatch('getAllState', {load_all: true, country_code: store.state.global.currentBranch.country_code});
      }
      return response;
    },
    async deleteState({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.deleteState(payload.uuid);
      if (response.success) {
        dispatch('getTableData');
        dispatch('getAllState', {load_all: true, country_code: store.state.global.currentBranch.country_code});
      }
      return response;
    },
    async getAllState({commit}, payload) {
      const {success, body} = await SalesTaxConfigurationService.getStatesByCountryCode(payload);
      if (success) {
        commit('getAllState', body);
      }
    },
    showCountyModal({commit}, object = null) {
      commit('showCountyModal', _.cloneDeep(object));
    },
    hideCountyModal({commit}) {
      commit('hideCountyModal');
    },
    async createCounty({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.createCounty(payload);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateCounty({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.updateCounty(payload);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async deleteCounty({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.deleteCounty(payload.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    showCityModal({commit}, object = null) {
      commit('showCityModal', _.cloneDeep(object));
    },
    hideCityModal({commit}) {
      commit('hideCityModal');
    },
    async createCity({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.createCity(payload);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateCity({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.updateCity(payload);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async deleteCity({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.deleteCity(payload.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async changeThresholdStatus({dispatch}, payload) {
      const response = await SalesTaxConfigurationService.changeThresholdStatus(payload);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async getCountiesByState({commit, state}, payload) {
      const searchModel = state.state.tableData.searchModel;
      const params = {
        ...payload,
        county_name: searchModel.county_name,
        city_name: searchModel.city_name,
      }
      const stateUuid = payload.state_uuid;
      commit('updateCountyTableLoading', {state_uuid: stateUuid, loading: true});
      const {success, body} = await SalesTaxConfigurationService.getCounties(params, 'state,num_cities');
      commit('updateCountyTableLoading', {state_uuid: stateUuid, loading: false});
      if (success) {
        commit('setCounties', {state_uuid: stateUuid, result: body});
      }
    },
    async getCitiesByCounty({commit, state}, payload) {
      const params = {
        ...payload,
        city_name: state.state.tableData.searchModel.city_name,
      }
      const stateUuid = payload.state_uuid;
      const countyUuid = payload.county_uuid;
      commit('updateCityTableLoading', {state_uuid: stateUuid, county_uuid: countyUuid, loading: true});
      const {success, body} = await SalesTaxConfigurationService.getCities(params, 'county.state');
      commit('updateCityTableLoading', {state_uuid: stateUuid, county_uuid: countyUuid, loading: false});
      if (success) {
        commit('setCities', {state_uuid: stateUuid, county_uuid: countyUuid, result: body});
      }
    },
    addExpandedState({commit}, stateUUid) {
      commit('addExpandedState', stateUUid);
    },
    removeExpandedState({commit}, stateUUid) {
      commit('removeExpandedState', stateUUid);
    },
    addExpandedCounty({commit}, countyUuid) {
      commit('addExpandedCounty', countyUuid);
    },
    removeExpandedCounty({commit}, {countyUuid, stateUuid}) {
      commit('removeExpandedCounty', {countyUuid, stateUuid});
    },
    removeExpandedTables({commit}) {
      commit('removeExpandedTables');
    },
  },
  mutations: {
    showStateModal: (state, object) => {
      state.state.modal.show = true;
      state.state.modal.object = object;
    },
    hideStateModal: state => state.state.modal.show = false,
    updateTableData: (state, payload) => state.state.tableData = {...state.state.tableData, ...payload},
    updateTableLoading: (state, payload) => state.state.tableData.loading = payload,
    updateSearchModel: (state, searchModel) => state.state.tableData.searchModel = searchModel,
    resetSearchModel: (state) => state.state.tableData.searchModel = new StateSearch(),
    updateState: (state, payload) => {
      const index = state.state.tableData.rows.findIndex(u => u.uuid === payload.uuid);
      if (index !== -1) {
        state.state.tableData.rows[index] = {...state.state.tableData.rows[index], ...payload};
        state.state.tableData.rows = [...state.state.tableData.rows];
      }
    },
    getAllState: (state, payload) => state.state.countryStates = [...payload],
    showCountyModal: (state, object) => {
      state.county.modal.show = true;
      state.county.modal.object = object;
    },
    hideCountyModal: state => state.county.modal.show = false,
    showCityModal: (state, object) => {
      state.city.modal.show = true;
      state.city.modal.object = object;
    },
    hideCityModal: state => state.city.modal.show = false,
    updateCountyTableLoading: (state, {state_uuid, loading}) => {
      const index = state.state.tableData.rows.findIndex(u => u.uuid === state_uuid);
      if (index !== -1) {
        state.state.tableData.rows[index]['loading'] = loading;
        state.state.tableData.rows = [...state.state.tableData.rows];
      }
    },
    setCounties: (state, {state_uuid, result}) => {
      const index = state.state.tableData.rows.findIndex(u => u.uuid === state_uuid);
      if (index !== -1) {
        state.state.tableData.rows[index]['counties'] = result;
        state.state.tableData.rows[index]['_showDetails'] = true;
        state.state.tableData.rows = [...state.state.tableData.rows];
      }
    },
    updateCityTableLoading: (state, {state_uuid, county_uuid, loading}) => {
      const index = state.state.tableData.rows.findIndex(u => u.uuid === state_uuid);
      if (index !== -1) {
        const countyIndex = state.state.tableData.rows[index]['counties'].findIndex(u => u.uuid === county_uuid);
        if (countyIndex !== -1) {
          state.state.tableData.rows[index]['counties'][countyIndex]['loading'] = loading;
          state.state.tableData.rows = [...state.state.tableData.rows];
        }
      }
    },
    setCities: (state, {state_uuid, county_uuid, result}) => {
      const index = state.state.tableData.rows.findIndex(u => u.uuid === state_uuid);
      if (index !== -1) {
        const countyIndex = state.state.tableData.rows[index]['counties'].findIndex(u => u.uuid === county_uuid);
        if (countyIndex !== -1) {
          state.state.tableData.rows[index]['counties'][countyIndex]['cities'] = result;
          state.state.tableData.rows[index]['counties'][countyIndex]['_showDetails'] = true;
          state.state.tableData.rows = [...state.state.tableData.rows];
        }
      }
    },
    addExpandedState: (state, stateUuid) => state.state.showStateDetails.push(stateUuid),
    removeExpandedState: (state, stateUuid) => {
      state.state.showStateDetails = state.state.showStateDetails.filter(id => id !== stateUuid);
      const index = state.state.tableData.rows.findIndex(u => u.uuid === stateUuid);
      if (index !== -1) {
        state.state.tableData.rows[index]['_showDetails'] = false;
        state.state.tableData.rows = [...state.state.tableData.rows];
      }
    },
    addExpandedCounty: (state, countyUuid) => state.state.showCountyDetails.push(countyUuid),
    removeExpandedCounty: (state, {countyUuid, stateUuid}) => {
      state.state.showCountyDetails = state.state.showCountyDetails.filter(id => id !== countyUuid);
      const index = state.state.tableData.rows.findIndex(u => u.uuid === stateUuid);
      if (index !== -1) {
        const countyIndex = state.state.tableData.rows[index]['counties'].findIndex(u => u.uuid === countyUuid);
        if (countyIndex !== -1) {
          state.state.tableData.rows[index]['counties'][countyIndex]['_showDetails'] = false;
        }
      }
      state.state.tableData.rows = [...state.state.tableData.rows];
    },
    removeExpandedTables: (state) => {
      state.state.showStateDetails = [];
      state.state.showCountyDetails = [];
      state.state.tableData.rows.forEach(st => {
        st['_showDetails'] = false;
        if (st['counties'] && st['counties'].length) {
          st['counties'].forEach(county => {
            county['_showDetails'] = false;
          })
        }
      })
      state.state.tableData.rows = [...state.state.tableData.rows];
    },
  }
};
